<ng-container *transloco="let t; read: 'comparison-filter-item.date-item'">
  <xi-calendar
    placeholder="{{ t('placeholder') }}"
    [data]="displayValue?.fixedRange"
    [checkedListId]="displayValue?.relativeRange"
    [mode]="calendarMode"
    [popoutView]="true"
    [maxDate]="maxDate"
    [localization]="{
      firstInputPlaceholder: t('first-placeholder'),
      secondInputPlaceholder: t('second-placeholder'),
      startDate: t('start-date'),
      endDate: t('end-date'),
      errorString: t('error-string'),
      leftText: t('left-text'),
      rightText: t('right-text'),
      to: t('to'),
      custom: t('custom'),
      applyBtn: t('apply-button'),
      cancelBtn: t('cancel-button'),
      noSelection: t('no-selection'),
    }"
    [class.kxi-calendar--disabled]="!isEnabled"
    (onValueChange)="onFilterValueSet($event)"
    (onToggle)="calendarMode = $event.detail.mode"
  ></xi-calendar>
</ng-container>
